import { createHttpMiddleware, SWRConfig, SWRConfiguration } from '@tiger/swr';
import { App as AntApp, ConfigProvider } from 'antd';
import { Provider } from 'mobx-react';
import { useMemo } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { legacyLogicalPropertiesTransformer, StyleProvider } from '@ant-design/cssinjs';
import EmptyData from 'components/EmptyData';
import ErrorBox from 'components/ErrorBox';
import { ModalRoot } from 'components/Modal';
import Agreement from 'modules/Agreement';
import Dlapp from 'modules/Dlapp';
import Transaction from 'modules/Transaction';
import { ErrorBoundary } from 'utils/bugsnag';
import http from 'utils/http';
import App from './App';
import { localeConfig, themeConfig } from './config';
import { useMountContext } from './context';
import RedirectNew from './RedirectNew';

const ErrorFallback: React.FC = () => {
    const handleClick = () => {
        window.location.reload();
    };

    return (
        <ErrorBox error={__('Something went wrong. Please try again')} onClick={handleClick} btnText={__('Refresh')} />
    );
};

const Root: React.FC = () => {
    const swrConfig: SWRConfiguration = useMemo(
        () => ({
            errorRetryCount: 3,
            use: [createHttpMiddleware(http.request)]
        }),
        []
    );
    const { isEmbedded } = useMountContext();

    return (
        // 在table等组件loading的时候会展示一个Empty组件: 根据设计标准, 全局替换empty组件, 统一使用项目内自定义的EmptyData组件
        <ConfigProvider renderEmpty={() => <EmptyData />} theme={themeConfig} locale={localeConfig}>
            {/** 样式兼容：https://ant.design/docs/react/compatible-style-cn */}
            <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]}>
                <SWRConfig value={swrConfig}>
                    <AntApp>
                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                            <Provider>
                                <BrowserRouter>
                                    <Routes>
                                        {/** 前3个处理重定向逻辑 */}
                                        <Route path="retrive/*" element={<RedirectNew linkType="retrive" />} />
                                        <Route path="safe/*" element={<RedirectNew linkType="safe" />} />
                                        <Route path="personal/*" element={<RedirectNew linkType="personal" />} />
                                        <Route path="transaction/*" element={<Transaction />} />
                                        <Route path="dlapp" element={<Dlapp />} />
                                        <Route path="agreement/:id" element={<Agreement isAgreement />} />
                                        <Route path="statement/:id" element={<Agreement />} />
                                        <Route path="*" element={<App isEmbedded={isEmbedded} />} />
                                    </Routes>
                                    <ModalRoot />
                                </BrowserRouter>
                            </Provider>
                        </ErrorBoundary>
                    </AntApp>
                </SWRConfig>
            </StyleProvider>
        </ConfigProvider>
    );
};

export default Root;
